<div class="modal-header" id="internal-info-close-modal-title">
    <h3 class="modal-title" id="modal-title">{{ model.title }}</h3>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <div class="col" [innerHTML]="model.message"></div>
    </div>
</div>
<div class="modal-footer">
    @if (model.backMessage) {
        <button class="btn btn-primary me-auto" (click)="onBackClick()">
            {{ model.backMessage }}
        </button>
    }
    @if (model.noMessage) {
        <button class="btn btn-secondary customNoClass" (click)="onNoClicked()">
            {{ model.noMessage }}
        </button>
    }
    @if (model.showYes) {
        <button class="btn btn-primary" (click)="onYesClicked()">{{ model.yesMessage }}</button>
    }
</div>
